package com.arena_web.data.api

import com.arena_web.data.dto.CreateUserPostCommentRequest
import com.arena_web.data.dto.CreateUserPostRequest
import com.arena_web.data.dto.CreatedCommentIdDto
import com.arena_web.data.dto.ImageUploadResponse
import com.arena_web.data.dto.UserPostCommentPageDto
import com.arena_web.data.dto.UserPostDto
import com.arena_web.data.dto.UserPostPageDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiDelete
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import com.arena_web.data.http.apiPostMultipart
import io.ktor.client.*

class UserPostApi(private val client: HttpClient) {

    suspend fun getMyPosts(params: Map<String, String> = emptyMap()): ApiResponse<UserPostPageDto> {
        return client.apiGet("v1/users/me/posts", params)
    }

    suspend fun getPost(postId: String): ApiResponse<UserPostDto> {
        return client.apiGet("v1/users/me/posts/$postId")
    }

    suspend fun createPost(request: CreateUserPostRequest): ApiResponse<UserPostDto> {
        return client.apiPost("v1/users/me/posts", request)
    }

    suspend fun deletePost(postId: String): ApiResponse<Unit> {
        return client.apiDelete("v1/users/me/posts/$postId")
    }

    suspend fun uploadImage(
        fileBytes: ByteArray,
        fileName: String,
        contentType: String
    ): ApiResponse<ImageUploadResponse> {
        return client.apiPostMultipart(
            "v1/users/me/posts/upload-image",
            fileBytes,
            fileName,
            contentType
        )
    }

    // ── Comments ──────────────────────────────────────────────────────────

    suspend fun getComments(
        postId: String,
        params: Map<String, String> = emptyMap(),
    ): ApiResponse<UserPostCommentPageDto> {
        return client.apiGet("v1/users/posts/$postId/comments", params)
    }

    suspend fun createComment(
        postId: String,
        request: CreateUserPostCommentRequest,
    ): ApiResponse<CreatedCommentIdDto> {
        return client.apiPost("v1/users/posts/$postId/comments", request)
    }

    suspend fun deleteComment(commentId: String): ApiResponse<Unit> {
        return client.apiDelete("v1/users/posts/comments/$commentId")
    }

    suspend fun likeComment(commentId: String): ApiResponse<Map<String, Boolean>> {
        return client.apiPost("v1/users/posts/comments/$commentId/like")
    }
}
